import Vue from 'vue';
import App from './App.vue';

import i18next from './languages';
import VueI18Next from '@panter/vue-i18next';
// import vueToPdf from 'vue-to-pdf';

Vue.use(VueI18Next);

// Vue.use(vueToPdf);

const i18n = new VueI18Next(i18next);

// Dashboard template
import ArgonDashboard from './plugins/argon-dashboard';
Vue.use(ArgonDashboard);

// Sweetalert
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
const options = {
  showCancelButton: true,
  confirmButtonText: 'Tamam',
  cancelButtonText: 'Vazgeç',
};
Vue.use(VueSweetalert2, options);

// V-mask Directive for input formatting
import { VueMaskDirective } from 'v-mask';
Vue.directive('mask', VueMaskDirective);

// Notifications
import Notifications from 'vue-notification';
Vue.use(Notifications);
import notificationsMixin from './mixins/notifications';
Vue.mixin(notificationsMixin);

// Registering VueEasyLightbox for your VueApp.
import VueEasyLightbox from 'vue-easy-lightbox';
Vue.use(VueEasyLightbox);

// Bootstrap
import BootstrapVue from 'bootstrap-vue';
Vue.use(BootstrapVue);

// Form Validation
import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);

// import 'ckeditor4/ckeditor.js';
import CKEditor from 'ckeditor4-vue';
Vue.use(CKEditor);
import VueFlagIcon from 'vue-flag-icon';

Vue.use(VueFlagIcon);

// Select component
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
Vue.component('v-select', vSelect);

import router from './router';
import store from './store';

new Vue({
  router,
  store,
  i18n: i18n,
  render: (h) => h(App),
}).$mount('#app');
